import { useEffect, useState } from "react";

import { getData, onlyUniqueValuesInObject } from "../../../../../services";
import { GrossRentalRevenues } from "../../../../../components/parts";

export const GrossRentalRevenuesComponent = ({ buildingId, complexId }) => {
  let url = `/praas/v2/buildings/properties/gross-rental-revenues/`;

  if (buildingId) {
    url = `/praas/v2/buildings/${buildingId}/properties/rental-revenues/`;
  } else if (complexId) {
    url = `/praas/v2/complexes/${complexId}/properties/rental-revenues/`;
  }

  const [grossRentalRevenueChartData, setGrossRentalRevenueChartData] = useState([]);

  useEffect(() => {
    getData(url, (data) => {
      if (!onlyUniqueValuesInObject(data, 0)) {
        let positive = data.rental_revenue + (10 * data.rental_revenue) / 100;
        const totalVacancy = data.economic_vacancy + data.physical_vacancy;
        let negative = totalVacancy + (10 * totalVacancy) / 100;
        if ((data.rental_revenue > totalVacancy) & (totalVacancy > 0)) {
          negative = positive;
        } else if ((totalVacancy > data.rental_revenue) & (data.rental_revenue > 0)) {
          positive = negative;
        }
        setGrossRentalRevenueChartData([
          {
            name: "Page A",
            rental: 0,
            economic_vacancy: 0,
            physical_vacancy: 0,
            positive: positive,
            negative: -negative,
            total_vacancy: 0,
            hide: true,
          },
          {
            name: "Gross rental revenue",
            rental: data.rental_revenue,
            economic_vacancy: -data.economic_vacancy,
            physical_vacancy: -data.physical_vacancy,
            positive: positive,
            negative: -negative,
            total_vacancy: -totalVacancy,
          },
          {
            name: "Page C",
            rental: 0,
            economic_vacancy: 0,
            physical_vacancy: 0,
            positive: positive,
            negative: -negative,
            total_vacancy: 0,
            hide: true,
          },
        ]);
      }
    });
  }, [buildingId, complexId]);

  return <GrossRentalRevenues chartData={grossRentalRevenueChartData} />;
};
